import { useUiEvent } from '@lingoda/analytics';
import { trans } from '@lingoda/i18n';
import { actionGoToQuiz } from '@lingoda/quiz-analytics';
import { studentQuizNextPath } from '@lingoda/router';
import { Box, Button, Img, Paper, styled } from '@lingoda/ui';
import { LastReview, Title } from './Entry';
import prepareImg from './assets/practise-vocabulary.svg?url';

interface EntryPendingProps {
    lastReview?: string | Date;
}

export const EntryPending = ({ lastReview }: EntryPendingProps) => {
    const addEvent = useUiEvent();

    return (
        <Wrapper variant="outlined" data-cy="quiz-entry">
            <Content>
                <Box>
                    <Title mb={0.5}>
                        {trans('entry-incomplete-title', {}, 'quiz-practice-dashboard')}
                    </Title>
                    {lastReview && <LastReview date={lastReview} />}
                </Box>
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        href={studentQuizNextPath()}
                        onClick={() => void addEvent(actionGoToQuiz())}
                    >
                        {trans('entry-incomplete-cta', {}, 'quiz-practice-dashboard')}
                    </Button>
                </Box>
            </Content>
            <BgImage src={prepareImg} aria-hidden="true" />
        </Wrapper>
    );
};

const Wrapper = styled(Paper)(({ theme }) => ({
    position: 'relative',
    overflow: 'hidden',
    height: '100%',
    minHeight: '14.75rem',
    padding: theme.spacing(4),
    background: theme.colors.brand.pink,
}));

const Content = styled(Box)(({ theme }) => ({
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(8),
    height: '100%',
}));

const BgImage = styled(Img)(({ theme }) => ({
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));
